<template>
    <tr v-if="mapping.jiraTitle !== undefined && mapping.tfsTitle !== undefined" class="tfs4jira-mapping-row" style="background-color: rgb(255, 255, 255);">
        <td class="tfs4jira-mapping-row-left">
            <div class="tfs4jira-mapping-value-text">
                <div class="tfs4jira-mapping-value-text-label">{{mapping.jiraTitle}}</div>
                <div class="subtitle" v-if="mapping.jiraSubtitle"> {{ mapping.jiraSubtitle }}</div>
            </div>
        </td>
        <td class="tfs4jira-mapping-row-direction"><div class="tfs4jira-mapping-row-direction-both" title=""> </div></td>
        <td class="tfs4jira-mapping-row-right">
            <div class="tfs4jira-mapping-value-text">
                <button :disabled="mapping.duringProcessing" @click="removeMapping(mapping)" class="tfs4jira-mapping-row-operation tfs4jira-merged-mapping-remove tfs4jira-rounded-button" title="Remove">
                    <img :src="imagePath + 'delete-icon.svg'">
                </button>
                {{ mapping.tfsTitle }}
                <div class="subtitle" v-if="mapping.tfsSubtitle"> {{ mapping.tfsSubtitle }}</div>
                <button class="tfs4jira-rounded-button reverse"
                        v-show="canBeSwitched()"
                        :disabled="mapping.duringProcessing"
                        :title="switchTitleText()"
                        @click="switchTfsLink(mapping)">
                    <img :src="imagePath + 'reverse-icon.svg'">
                </button>
            </div>
        </td>
    </tr>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { NAMESPACE as MAPPINGS_NAMESPACE } from './../../store/modules/mappings.js';
    import { NAMESPACE as APP_NAMESPACE } from './../../store/modules/app.js';

    export default {
        props: {
            mapping: Object,
            isLinksMapping: Boolean
        },
        computed: mapGetters({
            imagePath: APP_NAMESPACE.getters.IMAGE_PATH
        }),
        methods: {
            ...mapActions({
                removeMapping: MAPPINGS_NAMESPACE.actions.REMOVE_MAPPING,
                switchTfsLink: MAPPINGS_NAMESPACE.actions.SWITCH_TFS_LINK
            }),
            switchTitleText() {
                return "Switch to " + this.mapping.invertedTitle;
            },
            canBeSwitched() {
                return this.isLinksMapping && this.mapping.tfsValue && this.mapping.tfsValue.hasInvertedVersion;
            }
        }
    }
</script>

<style scoped>
p.switch {
    font-size: 13px;
    margin: 0;
}

td {
    position: relative;
}

button {
    height: 22px;
    line-height: 0;
}

button:disabled {
    opacity: 0.4;
    cursor: initial;
}

button.reverse {
    width: 22px;
    height: 22px;
    padding: 0;
    margin-top: -2px;
}

button.reverse img {
    width: 13px;
    vertical-align: middle;
    height: 13px;
}   

button.tfs4jira-mapping-row-operation {
    position: absolute;
    right: 0;
    margin: 0;
    top: 50%;
    padding: 0px;
    transform: translateY(-11px);
}

.subtitle{
    font-size: 10px;
    color: #6B778C;
}
</style>


// WEBPACK FOOTER //
// src/components/mappings/MappingRow.vue